import React from "react";
import { useParams, Link, useHistory } from "react-router-dom";
import FileList from "../../components/FileList";
import BotList from "../../components/BotList";
import { Row, Col, Button } from "reactstrap";
import PageLayout from "../../components/PageLayout";
import Loading from "../../components/Loading";
import { useAuth0 } from "../../auth/react-auth0-wrapper"
import { getCollaudo, updateCollaudoDocs, getCollaudoBot } from "../../api/collaudo";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Can from "../../auth/Can";
import roles from "../../auth/roles";

const DocsCollaudo = () => {
    const [collaudo, setCollaudo] = React.useState();
    const [bot, setBot] = React.useState();
    const [loading, setLoading] = React.useState(true);
    const { onSuccess, activeTenant, user } = useAuth0();
    const { collaudoId } = useParams()
    const { push } = useHistory();

    const isAdmin = user.isInRole([roles.ADMIN], activeTenant)

    React.useEffect(() => {
        loadCollaudo();
    }, []);

    async function loadCollaudo() {
        try {
            setLoading(true);
            const collaudoRes = await getCollaudo(collaudoId);
            const collaudoBots = JSON.parse(await getCollaudoBot(collaudoId));
            setCollaudo(collaudoRes);
            setBot(collaudoBots.previousSteps);
        } finally {
            setLoading(false);
        }
    }

    const onDocsUpdated = async docs => {
        await updateCollaudoDocs(collaudo._id, docs);
        onSuccess()
    };

    if (loading) return <Loading />;

    return (
        <PageLayout
            title="Documenti collaudo"
            optionalNav={{ link: "/collaudo/list", text: "Elenco Collaudi" }}
        >
            {collaudo ? (
                <div>
                    <Row>
                        <Col>
                            <strong>{`Elenco documenti: Targa ${collaudo.plate} - IMEI ${collaudo.attributes.imei} - Tel. dispositivo ${collaudo.attributes.number} - Cliente ${collaudo.customer_name}`}</strong>
                            <FileList
                                category="collaudo"
                                initDocs={collaudo.meta.docs}
                                onDocsUpdated={onDocsUpdated}
                                blockDelete={() => !isAdmin}  //(name) => name.startsWith('certificatocollaudo') || 
                            />

                            {collaudo.status !== "firmato" && <Row>
                                <Col>
                                    <div className="float-right mt-2">
                                        <Link
                                            disabled={loading}
                                            to={`/collaudo/sign/${collaudo._id}`}
                                            className="btn btn-success"
                                        >
                                            <FontAwesomeIcon icon="signature" /> Firma il Collaudo
                                </Link>
                                    </div>
                                </Col>
                            </Row>}

                            <Can
                                roles={[roles.ADMIN]}
                                yes={() => (
                                    <div className="mt-4">
                                        <strong>{`Storico Collaudo`}</strong>
                                        <BotList
                                            initBots={bot}
                                            onDocsUpdated={onDocsUpdated}
                                            blockDelete={(name) => name.startsWith('certificatocollaudo')}
                                        />
                                    </div>
                                )}
                                no={() => null}
                            />
                            <Button
                                onClick={() => push('/collaudo/list')}
                                color="warning"
                                className="btn btn-warning mt-2 float-right "
                            >
                                <FontAwesomeIcon icon="reply" /> Torna
                            </Button>
                        </Col>
                    </Row>
                </div>
            ) : null}
        </PageLayout>
    );
};

export default DocsCollaudo;
